const moduleMap = {
	"./filePickerPageBootstrap": () => {
		return Promise.all([__webpack_require__.e(6775), __webpack_require__.e(3217), __webpack_require__.e(5205), __webpack_require__.e(9463), __webpack_require__.e(4914), __webpack_require__.e(7680), __webpack_require__.e(4294), __webpack_require__.e(6858), __webpack_require__.e(6488), __webpack_require__.e(8851), __webpack_require__.e(7383), __webpack_require__.e(2339), __webpack_require__.e(3568), __webpack_require__.e(6158), __webpack_require__.e(9610), __webpack_require__.e(3868), __webpack_require__.e(9106), __webpack_require__.e(5438), __webpack_require__.e(9890), __webpack_require__.e(379)]).then(() => (() => ((__webpack_require__(9939)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});